import React from "react";
import { Box, Botao, TipoBotao, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { PlanoService, RecadastramentoService } from "../../services";
import { MasterPage } from "..";
import { WebRecadParticipanteDadosEntidade } from "../../entidades";
import { Passos, GrupoRecadastramento } from ".";

interface Props {
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  Avancar: () => void;
  Voltar: () => void;
  setDadosPasso: any;
  Grupo: string;
  NumeroPassoAtual: number;
}

interface State {
  PPE: string;
  CorCheckbox: string;
  checked: boolean;
  ContriquiComRisco: boolean;
  condicaoAtivoAssistidoPlanoA: boolean;
}

export class Passo8 extends React.Component<Props, State> {
  private page = React.createRef<MasterPage>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      PPE: "",
      CorCheckbox: "danger",
      checked: false,
      ContriquiComRisco: false,
      condicaoAtivoAssistidoPlanoA: false,
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      const ContriquiComRisco = (await RecadastramentoService.BuscarContribPensao()).length > 0;

      const planos = await PlanoService.Buscar();

      const condicaoAtivoAssistidoPlanoA = planos.some(
        (x) =>
          x.CD_PLANO === "0001" &&
          (x.CD_CATEGORIA === "1" || // ativo
            x.CD_CATEGORIA === "3" || // ativo
            x.CD_CATEGORIA === "6" || // ativo
            x.CD_CATEGORIA === "4") // assistido
      );

      this.setState({
        PPE: this.props.DadosOriginais.POLIT_EXP,
        ContriquiComRisco,
        condicaoAtivoAssistidoPlanoA,
      });
    } catch (err) {
      this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  Ativo = () => {
    return this.props.Grupo === GrupoRecadastramento.ATIVO;
  };

  Assistido = () => {
    return this.props.Grupo === GrupoRecadastramento.ASSISTIDO;
  };

  AssistidoEspecial = () => {
    return this.props.Grupo === GrupoRecadastramento.ASSISTIDO_ESPECIAL;
  };

  Pensionista = () => {
    return this.props.Grupo === GrupoRecadastramento.PENSIONISTA;
  };

  SaldadoExtraord = () => {
    return this.props.Grupo === GrupoRecadastramento.SALDADO_EXTRAORD;
  };

  NaoSaldadoExtraord = () => {
    return this.props.Grupo !== GrupoRecadastramento.SALDADO_EXTRAORD;
  };

  NaoAssistidoEspecial = () => {
    return this.props.Grupo !== GrupoRecadastramento.ASSISTIDO_ESPECIAL;
  };

  NaoPensionista = () => {
    return this.props.Grupo !== GrupoRecadastramento.PENSIONISTA;
  };

  SalvarDados = () => {
    const d = {
      PPE: this.state.PPE,
    };
    this.props.setDadosPasso(Passos.Passo8, d);
  };

  CondicaoPasso7 = async () => {
    // Passo 7 deverá ser sempre ser mostrado para qualquer participante das categorias ATIVO e ASSISTIDO do PLANO A ("0001")
    // Passo 7 não estará disponível para os grupos SALDADO EXTRAORD. ASSISTIDO ESPECIAL e PENSIONISTA.
    // Passo 7 estará disponível apenas para quem contribui com RISCO - PENSÃO
    const GrupoPermitido = this.NaoSaldadoExtraord() || this.NaoAssistidoEspecial() || this.NaoPensionista();
    return this.state.condicaoAtivoAssistidoPlanoA || (GrupoPermitido && this.state.ContriquiComRisco);
  };

  Voltar = () => {
    this.SalvarDados();

    this.props.Voltar();
  };

  Proximo = () => {
    this.SalvarDados();
    this.props.Avancar();
  };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Pessoa Exposta Politicamente`}>
        <Alerta tipo={TipoAlerta.info} mensagem={"Declaro para fins do atendimento às exigências da Instrução PREVIC nº 34/2020 que:"} />

        <div className="box d-flex flex-column p-3">
          <label className="d-flex align-items-center">
            <input
              name={"PolitExp"}
              className={"m-2"}
              value={"S"}
              type={"radio"}
              checked={this.state.PPE === "S"}
              onChange={(e: any) => {
                this.setState({ PPE: e.target.value });
              }}
            />
            {'ESTOU enquadrado(a) como "Pessoa Exposta Politicamente"'}
          </label>

          <label className="d-flex align-items-center">
            <input
              name={"PolitExp"}
              className={"m-2"}
              value={"N"}
              type={"radio"}
              checked={this.state.PPE !== "S"}
              onChange={(e: any) => {
                this.setState({ PPE: e.target.value });
              }}
            />
            {'NÃO ESTOU enquadrado(a) como "Pessoa Exposta Politicamente'}
          </label>
        </div>

        <Alerta
          tipo={TipoAlerta.info}
          mensagem={'Sendo "pessoa exposta politicamente" pessoa natural que desempenha ou tenha desempenhado, nos cinco anos anteriores, cargo, emprego ou função pública relevantes, assim como funções relevantes em organizações internacionais.'}
        />

        <Alerta tipo={TipoAlerta.danger} ref={this.alerta} />

        <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

        <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />
      </Box>
    );
  }
}
